
import { Barcode } from "@/utils/label-layout/barcode";
import Vue from "vue";
import AppDraggableResizeCombo from "@/components/layout-editor/DraggableResizeCombo.vue";

export default Vue.extend({
	props: {
		barcode: {
			type: Object as ()=>Barcode,
			required: true
		},
	},
	components: {
		AppDraggableResizeCombo
	}
});
